<template>
    <div class="container remove-padding-margin">
        <div class="fixed-top bg-white">
            <div class="nav-center pageDefault">
                <div class="row set-row d-flex">
                    <div class="remove-padding navbar-icon-left" @click="back">
                        <img class="remove-padding-margin" @click="" src="../../assets/gambar/back-blue.svg">
                    </div>
                    <div class="text-center remove-padding flex-1 font-weight-600">
<!--                        Buat Email-->
                    </div>
                    <div class="navbar-icon-right remove-padding">

                    </div>
                </div>
            </div>
        </div>
        <main>

        </main>
    </div>
</template>

<script>
    export default {
        name: "PusatBantuan",
        methods: {
            back() {
                this.$router.push('/detailakunowner')
            },
        }
    }
</script>

<style scoped>

</style>